import React from "react";
import PropTypes from "prop-types";

function HeaderCell({ column }) {
  const { dataKey, label } = column;
  return <>{label ? label : dataKey}</>;
}

HeaderCell.propTypes = {
  col: PropTypes.shape({
    dataKey: PropTypes.string,
    label: PropTypes.string
  })
};

HeaderCell.defaultProps = {
  col: {}
};

export default HeaderCell;
